import React, { useState, useEffect } from "react";
import { Trans } from "react-i18next";

const List = ({ employee, client }) => {
    const [data, setData] = useState(null);
  
    useEffect(
      () =>
        void (async () => {
          const data = await client
            .get(`employees/${employee.id}/end_of_service`)
            .get("data");
          if (data.length > 0) setData(data[0]);
        })(),
      [employee]
    );
  
    if (!data) return null;
  
    return (
      <div>
        <h4>
          <Trans>End of Service Calculation</Trans>
        </h4>
        <table className="table table-striped employee-holiday-table">
          <thead>
            <tr>
              <th className="font-weight-semibold p-2">
                <Trans>Description</Trans>
              </th>
              <th className="font-weight-semibold p-2">
                <Trans>Amount</Trans>
              </th>
              <th />
            </tr>
          </thead>
          <tbody className="small">
            {data.lines.map((i) => (
              <tr key={i.id}>
                <td className="p-2">{i.description ? i.description : "-"}</td>
                <td className="p-2">{i.amount}</td>
                <td className="p-2" />
              </tr>
            ))}
          </tbody>
        </table>
        <span className="font-weight-bold float-right">
          <Trans>Total</Trans>: {data.net_pay}
        </span>
        <br />
        <br />
        <br />
      </div>
    );
  };

export default List